import { Options } from 'src/app/shared/models/options';
import { createAction, props } from '@ngrx/store';

export const setShowError = createAction(
  '[contactscreen] setShowError',
  props<{ payload: boolean }>(),
);
export const setGoBack = createAction(
  '[contactscreen] setGoBack',
  props<{ payload: string }>(),
);
export const flagLoadScript = createAction(
  '[contactscreen] setFlagLoadScript',
  props<{ payload: boolean }>(),
);
export const setToken = createAction(
  '[contactscreen] setToken',
  props<{ payload: string }>(),
);
export const setDeeplink = createAction(
  '[contactscreen] setDeeplink',
  props<{ payload: string }>(),
);
export const setCustomerId = createAction(
  '[contactscreen] setCustomerId',
  props<{ payload: string }>(),
);
export const setCustomerBirthDate = createAction(
  '[contactscreen] setCustomerBirthDate',
  props<{ payload: string }>(),
);
export const setVersionApp = createAction(
  '[contactscreen] setVersionApp',
  props<{ payload: string }>(),
);
export const setOperatingSystem = createAction(
  '[contactscreen] setOperatingSystem',
  props<{ payload: string }>(),
);
export const setOptions = createAction(
  '[contactscreen] setOptions',
  props<{ payload: Options }>(),
);
export const setGlobalId = createAction(
  '[contactscreen] setGlobalId',
  props<{ payload: string }>(),
);
export const setCdaJourney = createAction(
  '[contactscreen] setCdaJourney',
  props<{ payload: string }>(),
);
